.header {
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
}

.appTitle {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 0.1rem;
  letter-spacing: -0.5px;
}

.subtitle {
  color: var(--text-light);
  font-size: 0.75rem;
}

@media (min-width: 480px) {
  .header {
    margin-bottom: 2rem;
  }
  
  .appTitle {
    font-size: 1.8rem;
  }
}

@media (min-width: 768px) {
  .appTitle {
    font-size: 2rem;
  }
}

@media (min-width: 992px) {
  .appTitle {
    font-size: 2.25rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

/* ダークモード対応 */
@media (prefers-color-scheme: dark) {
  .appTitle {
    color: var(--primary-color);
  }
  
  .subtitle {
    color: var(--text-light);
  }
} 